import type { IngredientNumericField } from "@scoopulator/api-contracts";

export {
  ingredientNumericFields,
  type IngredientNumericField,
} from "@scoopulator/api-contracts";
export function ingredientDisplayToValue(
  field: IngredientNumericField,
  value: number,
) {
  return field === "energyKcal" ? value : value / 100;
}
export function ingredientValueToDisplay(
  field: IngredientNumericField,
  value: number,
) {
  return field === "energyKcal" ? value : Number((value * 100).toPrecision(14));
}

export function roundIngredientFraction(value: number, displayStep: number) {
  return Number(
    (
      (Math.round((value * 100) / displayStep + 1e-10) * displayStep) /
      100
    ).toFixed(8),
  );
}
